var EAffiliateStatus = /*#__PURE__*/function (EAffiliateStatus) {
  EAffiliateStatus["Active"] = "active";
  EAffiliateStatus["Pending"] = "pending";
  EAffiliateStatus["Blocked"] = "blocked";
  return EAffiliateStatus;
}(EAffiliateStatus || {});
var EAffiliateLanguage = /*#__PURE__*/function (EAffiliateLanguage) {
  EAffiliateLanguage["English"] = "en";
  EAffiliateLanguage["German"] = "de";
  return EAffiliateLanguage;
}(EAffiliateLanguage || {});
export { EAffiliateLanguage, EAffiliateStatus };